export default __webpack_public_path__ + "static/media/bg-light4.c4cbcc56.jpg";